'use client'

import { useState } from 'react'
import Link from 'next/link'
import config from '../../data/site-config.json'

export default function ContactForm() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        service: ''
    })
    const [status, setStatus] = useState({ type: '', message: '' })
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)
        setStatus({ type: '', message: '' })

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            })

            if (response.ok) {
                setStatus({ type: 'success', message: 'Thank you! We will contact you within 30 minutes.' })
                setFormData({ name: '', email: '', phone: '', message: '', service: '' })
            } else {
                setStatus({ type: 'error', message: 'Something went wrong. Please try again or call us directly.' })
            }
        } catch (error) {
            setStatus({ type: 'error', message: 'Network error. Please call us directly.' })
        }

        setIsSubmitting(false)
    }

    return (
        <form onSubmit={handleSubmit} style={{
            background: 'white',
            padding: 'var(--spacing-md)',
            borderRadius: 'var(--border-radius)',
            boxShadow: 'var(--shadow-lg)'
        }}>
            <h3 style={{ marginBottom: 'var(--spacing-md)', color: 'var(--primary)' }}>Send Us a Message</h3>

            {status.message && (
                <div style={{
                    padding: 'var(--spacing-sm)',
                    marginBottom: 'var(--spacing-sm)',
                    borderRadius: 'var(--border-radius)',
                    background: status.type === 'success' ? '#d4edda' : '#f8d7da',
                    color: status.type === 'success' ? '#155724' : '#721c24'
                }}>
                    {status.message}
                </div>
            )}

            <div style={{ marginBottom: 'var(--spacing-sm)' }}>
                <label style={{ display: 'block', marginBottom: '0.3rem', fontWeight: '500' }}>Your Name *</label>
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    autoComplete="name"
                    style={{
                        width: '100%',
                        padding: '0.8rem',
                        border: '1.5px solid var(--gray-300)',
                        borderRadius: 'var(--border-radius)',
                        fontSize: '1rem'
                    }}
                />
            </div>

            <div style={{ marginBottom: 'var(--spacing-sm)' }}>
                <label style={{ display: 'block', marginBottom: '0.3rem', fontWeight: '500' }}>Email Address *</label>
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    autoComplete="email"
                    style={{
                        width: '100%',
                        padding: '0.8rem',
                        border: '1.5px solid var(--gray-300)',
                        borderRadius: 'var(--border-radius)',
                        fontSize: '1rem'
                    }}
                />
            </div>

            <div style={{ marginBottom: 'var(--spacing-sm)' }}>
                <label style={{ display: 'block', marginBottom: '0.3rem', fontWeight: '500' }}>Phone Number *</label>
                <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    autoComplete="tel"
                    style={{
                        width: '100%',
                        padding: '0.8rem',
                        border: '1.5px solid var(--gray-300)',
                        borderRadius: 'var(--border-radius)',
                        fontSize: '1rem'
                    }}
                />
            </div>

            <div style={{ marginBottom: 'var(--spacing-sm)' }}>
                <label style={{ display: 'block', marginBottom: '0.3rem', fontWeight: '500' }}>Service Interest</label>
                <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    style={{
                        width: '100%',
                        padding: '0.8rem',
                        border: '1.5px solid var(--gray-300)',
                        borderRadius: 'var(--border-radius)',
                        fontSize: '1rem',
                        background: 'white'
                    }}
                >
                    <option value="">Select a service...</option>
                    <option value="car-removal">Free Car Removal</option>
                    <option value="cash-for-cars">Cash for Cars</option>
                    <option value="scrap-car">Scrap Car Removal</option>
                    <option value="4wd-removal">4WD/Truck Removal</option>
                    <option value="other">Other Inquiry</option>
                </select>
            </div>

            <div style={{ marginBottom: 'var(--spacing-md)' }}>
                <label style={{ display: 'block', marginBottom: '0.3rem', fontWeight: '500' }}>Message</label>
                <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    style={{
                        width: '100%',
                        padding: '0.8rem',
                        border: '1.5px solid var(--gray-300)',
                        borderRadius: 'var(--border-radius)',
                        fontSize: '1rem',
                        resize: 'vertical'
                    }}
                    placeholder="Tell us about your vehicle or inquiry..."
                />
            </div>

            <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
                style={{
                    width: '100%',
                    padding: '1rem',
                    fontSize: '1.1rem',
                    opacity: isSubmitting ? 0.7 : 1
                }}
            >
                {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>

            <p style={{
                textAlign: 'center',
                marginTop: 'var(--spacing-sm)',
                fontSize: '0.9rem',
                color: 'var(--gray-800)'
            }}>
                Or call us directly: <strong>{config.business.phone}</strong>
            </p>
        </form>
    )
}
